<template>
	<div>
		<div v-if="!entries.length" class="text-center text-body-medium text-medium-emphasis pa-4">{{ t(offerRef.offerKey ? 'PromoLocalOfferNoProduct' : 'PromoNoProductsPublished') }}</div>
		<v-list v-else class="pa-0 bg-transparent">
			<template v-for="(entry, index) in entries" :key="entry.key">
				<v-divider v-if="index" />
				<PromoProductListItem :campaign="campaign" :offer="offer" :offer-ref="offerRef" :phase="phase" :product-id="entry.productId" :free="entry.free" @open="openAt(index)" />
			</template>
		</v-list>
		<PromoProductSheet v-model="sheetOpen" v-model:index="sheetIndex" :entries="entries" :campaign="campaign" :offer="offer" :offer-ref="offerRef" :phase="phase" />
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { getOfferInfo, listedProductIds } from '@/utils/domain/promo/promoModel';
import { freeRowOf } from '@/utils/domain/promo/promoFree';
import PromoProductListItem from './PromoProductListItem.vue';
import PromoProductSheet from './PromoProductSheet.vue';

const props = defineProps({
	campaign: { type: Object, required: true },
	offer: { type: Object, required: true },
	offerRef: { type: Object, required: true },
	phase: { type: String, required: true },
});

const { snapshot, t } = usePromoStep();
const sheetOpen = ref(false);
const sheetIndex = ref(0);

const entries = computed(() =>
	listedProductIds(snapshot.value, props.campaign, props.offer, getOfferInfo(snapshot.value, props.offerRef.offerKey)).flatMap((productId) => {
		const main = { key: String(productId), productId, free: false };
		if (!freeRowOf(snapshot.value, props.offerRef, productId)) return [main];
		return [main, { key: `${productId}-free`, productId, free: true }];
	})
);

function openAt(index) {
	sheetIndex.value = index;
	sheetOpen.value = true;
}
</script>
